<<template>
  <div class="detail-panel">
    <div class="btn-panel">
        <a v-if="this.action != 'View'" class="btn btn-default" @click="save">{{$rs["btn_save"]}}</a>
      <slot></slot>
    </div>
      <hr>
    <div class="row">
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["groupNo"]}}</span>
          <input type="text" class="form-control" v-bind:readonly='action=="View"' v-model="data.groupNo">
        </div>
    </div>  
    <div class="row">
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["groupName"]}}</span>
          <input type="text" class="form-control" v-bind:readonly='action=="View"' v-model="data.groupName">
        </div>
    </div>  
    <div class="row">
          <div class="input-group col-md-3">
            <span class="input-group-addon">{{rs["dayHour"]}}</span>
            <date-input :formater='"HH:mm"' class="form-control"  v-bind:readonly='action=="View"' v-model="dayHour"/>
          </div>
    </div>  
    <div class="row">
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["remark"]}}</span>
          <input type="text" class="form-control" v-bind:readonly='action=="View"' v-model="data.remark">
        </div>
    </div>
    <div class="row" style="margin-left:0">
      <div class="input-group" style="margin-left:0">
          <span class="input-group-addon" >{{rs["exDate"]}}</span>
        <div class="form-control col-md-10" style=" height: auto;min-height:26px;">
         <label style="margin-left: 5px;">
          <input type="checkbox" value="1" v-model="data.exDate"/>1</label>
         <label style="margin-left: 5px;">
          <input type="checkbox" value="2" v-model="data.exDate"/>2</label>
         <label style="margin-left: 5px;">
          <input type="checkbox" value="3" v-model="data.exDate"/>3</label>
         <label style="margin-left: 5px;">
          <input type="checkbox" value="4" v-model="data.exDate"/>4</label>
         <label style="margin-left: 5px;">
          <input type="checkbox" value="5" v-model="data.exDate"/>5</label>
         <label style="margin-left: 5px;">
          <input type="checkbox" value="6" v-model="data.exDate"/>6</label>
         <label style="margin-left: 5px;">
          <input type="checkbox" value="7" v-model="data.exDate"/>7</label>
         <label style="margin-left: 5px;">
          <input type="checkbox" value="8" v-model="data.exDate"/>8</label>
         <label style="margin-left: 5px;">
          <input type="checkbox" value="9" v-model="data.exDate"/>9</label>
         <label style="margin-left: 5px;">
          <input type="checkbox" value="10" v-model="data.exDate"/>10</label>
         <label style="margin-left: 5px;">
          <input type="checkbox" value="11" v-model="data.exDate"/>11</label>
         <label style="margin-left: 5px;">
          <input type="checkbox" value="12" v-model="data.exDate"/>12</label>
         <label style="margin-left: 5px;">
          <input type="checkbox" value="13" v-model="data.exDate"/>13</label>
         <label style="margin-left: 5px;">
          <input type="checkbox" value="14" v-model="data.exDate"/>14</label>
         <label style="margin-left: 5px;">
          <input type="checkbox" value="15" v-model="data.exDate"/>15</label>
         <label style="margin-left: 5px;">
          <input type="checkbox" value="16" v-model="data.exDate"/>16</label>
         <label style="margin-left: 5px;">
          <input type="checkbox" value="17" v-model="data.exDate"/>17</label>
         <label style="margin-left: 5px;">
          <input type="checkbox" value="18" v-model="data.exDate"/>18</label>
         <label style="margin-left: 5px;">
          <input type="checkbox" value="19" v-model="data.exDate"/>19</label>
         <label style="margin-left: 5px;">
          <input type="checkbox" value="20" v-model="data.exDate"/>20</label>
         <label style="margin-left: 5px;">
          <input type="checkbox" value="21" v-model="data.exDate"/>21</label>
         <label style="margin-left: 5px;">
          <input type="checkbox" value="22" v-model="data.exDate"/>22</label>
         <label style="margin-left: 5px;">
          <input type="checkbox" value="23" v-model="data.exDate"/>23</label>
         <label style="margin-left: 5px;">
          <input type="checkbox" value="24" v-model="data.exDate"/>24</label>
         <label style="margin-left: 5px;">
          <input type="checkbox" value="25" v-model="data.exDate"/>25</label>
         <label style="margin-left: 5px;">
          <input type="checkbox" value="26" v-model="data.exDate"/>26</label>
         <label style="margin-left: 5px;">
          <input type="checkbox" value="27" v-model="data.exDate"/>27</label>
         <label style="margin-left: 5px;">
          <input type="checkbox" value="28" v-model="data.exDate"/>28</label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="input-group col-md-9">
        <span class="input-group-addon" ><a @click.stop='showGp'>{{rs["bc"]}}</a></span>
        <div class="form-control" style=" height: auto;">
          <div v-for='item in data.items' class="input-group col-md-3">
            <span class="input-group-addon" >{{item.shiftName}}({{item.shiftNo}})</span>
            <select v-model='item.exType'>
              <option value="1">{{rs["exType1"]}}</option>
              <option value="2">{{rs["exType2"]}}</option>
            </select>
            <span v-if='item.exType==2' class="input-group-addon" style="padding:6px 2px" >>></span>
            <select v-if='item.exType==2' v-model="item.nshiftNo">
              <option v-for="s in data.items" :value="s.shiftNo">{{s.shiftName}}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <group v-if="isShowShift" @close="closeGp" :rs="rs" :shiftList="shiftList" :xdata="this.data.items"  />
  </div>
  
</template>

<<script>
import mixin from "@/fui/mixin";
import group from "./group";
export default {
  created(){
    let tmp 
    this.data.items.forEach(d=>{
      tmp = this.shiftList.find(x=>{
        return x.shiftNo==d.shiftNo
      })
      if (tmp) d.shiftName = tmp.shiftName
    })
    if (this.action == "Add" || this.action == "Copy")  {
      this.data.exDate=[]
    }
    //this.data.dayHour = this.formatter.fstime(this.data.dayHour)
  },
  props:["shiftList", "rs"],
  data(){
    return {
      isShowShift: false,
      xdata: []
    }
  },
  computed:{
    dayHour:{
      get(){return this.formatter.fstime(this.data.dayHour)},
      set(v){
        if (!v || v=="") this.data.dayHour = null
        else this.data.dayHour = "1900-01-01 " + v + ":00.000"
      }
    }
  },
  methods: {
    checkInput(){
       if (!this.checkNull(this.data.groupNo, "nullbh")) return false 
       if (!this.checkNull(this.data.groupName, "nullbz")) return false 
       //if (!this.checkNull(this.data.bc, "nullbc")) return false 
       //this.data.yxj = this.data.bc
       //this.data.bc = 1
       //this.data.dayHour = "1900-01-01 " + this.data.dayHour + ":00.000"

       return true
    }, 
    showGp(){
      this.isShowShift = true
    }, 
    closeGp(xd){
      let tmp
      const dt = []
      xd.forEach(d=>{
        tmp = this.data.items.find(x=>{
          return x.shiftNo==d.shiftNo
        })
        if (tmp) {
          d.exType = tmp.exType
        }
        dt.push(d)
      })
      this.data.items = dt
      this.isShowShift = false
    }
  },
  mixins: [mixin.detail],
  components: {
    group
  }
}
</script>


